// const apiBaseUrls = "http://192.168.1.19:5000/";
// export const imageBaseUrls = "http://192.168.1.19:5000/assets/";
// const mainUrl = "";

// const apiBaseUrls = "http://191.101.80.117:5000/";


const apiBaseUrls = "https://chriskelly.xyz/backend/";
// const apiBaseUrls = "http://localhost:5000/";

export const imageBaseUrls = "https://chriskelly.xyz/backend/assets/";
// const apiBaseUrls = "http://localhost:5000/";
// export const imageBaseUrls = "http://localhost:5000/assets/";


export const ApiURLs = {
    login:`${apiBaseUrls}admin/auth/login`,
    CHANGE_PASSWORD:`${apiBaseUrls}admin/auth/change-password`,
    RESET_NEW_PASSWORD:`${apiBaseUrls}admin/auth/reset-new-password`,
    EDIT_PROFILE:`${apiBaseUrls}admin/auth/edit-profile`,
    UPLOAD_IMAGE:`${apiBaseUrls}api/upload-image`,
    FORGOT_PASSWORD:`${apiBaseUrls}admin/auth/forgot-password`,
    GET_USERS:`${apiBaseUrls}admin/user`,
    EMAIL_UPDATE:`${apiBaseUrls}admin/updateEmail`,
    CATEGORIES:`${apiBaseUrls}admin/category`,
    ATTRIBUTE:`${apiBaseUrls}admin/attribute`,
    PLAN:`${apiBaseUrls}admin/plan`,
    VEHICLES:`${apiBaseUrls}admin/vehicles`,
    CONTACTUS:`${apiBaseUrls}admin/contact-us`,
    VEHICLESBULK:`${apiBaseUrls}admin/vehicles-bulk`,
    SETTINGS:`${apiBaseUrls}admin/setting`,
    VEHICLE_MAKE:`${apiBaseUrls}admin/vehicles-model`,
    BLOG:`${apiBaseUrls}admin/blog`,
    FAQS:`${apiBaseUrls}admin/faq`,
    ADREPORTS:`${apiBaseUrls}admin/ad-report`,
    ADS:`${apiBaseUrls}admin/ads`,

    // ADD_CATEGORY:`${apiBaseUrls}admin/category`,
     };